var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.listRouteName
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.listTitle) + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("優惠券序號")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 優惠券序號 ")]), _c('b-input-group', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_vm.isDeleteMode ? [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.closeDeleteMode
    }
  }, [_vm._v("取消")]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "danger",
      "disabled": !_vm.selectedRedeemCodes.length
    },
    on: {
      "click": _vm.deleteRedeemCodes
    }
  }, [_vm._v("刪除序號")])] : [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "mdi mdi-download"
  }), _vm._v("匯出")]), _c('b-dropdown', {
    ref: "settingDropdown",
    staticClass: "mr-2",
    attrs: {
      "text": "指派序號",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.showBatchAssignModal
    }
  }, [_vm._v("指定批次會員")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.showAssignModal(null);
      }
    }
  }, [_vm._v("指定單一會員")])], 1), _c('b-dropdown', {
    ref: "settingDropdown",
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.disableModifyButton,
      "text": "新增/刪除序號",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.showUploadModal
    }
  }, [_vm._v("批次上傳序號")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.showCreateModal
    }
  }, [_vm._v("新增單筆序號")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.openDeleteMode
    }
  }, [_vm._v("刪除序號")])], 1)], _c('b-form-input', {
    attrs: {
      "placeholder": "搜尋序號、會員名稱、手機、外部編碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 2), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('span', [_vm._v("優惠券名稱：" + _vm._s(_vm.redeemCodeBundle.name))]), _c('br'), _c('span', [_vm._v("序號總數：" + _vm._s(_vm.redeemCodesMeta.total))]), _c('br'), _c('span', [_vm._v("未指派數目：" + _vm._s(_vm.redeemCodesMeta.not_belong_count))]), _c('br'), _c('span', [_vm._v("未領取數目：" + _vm._s(_vm.redeemCodesMeta.belong_count))]), _c('br'), _c('span', [_vm._v("已領取數目(未使用)：" + _vm._s(_vm.redeemCodesMeta.apply_count))]), _c('br'), _c('span', [_vm._v("已領取數目(已使用)：" + _vm._s(_vm.redeemCodesMeta.redeem_count))]), _c('br')])], 1), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.redeemCodes,
      "fields": _vm.fields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "head(checkbox)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.toggleSelectAll
          },
          model: {
            value: _vm.isSelectAll,
            callback: function callback($$v) {
              _vm.isSelectAll = $$v;
            },
            expression: "isSelectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(checkbox)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.id
          },
          on: {
            "change": _vm.toggleSelect
          },
          model: {
            value: _vm.selectedRedeemCodes,
            callback: function callback($$v) {
              _vm.selectedRedeemCodes = $$v;
            },
            expression: "selectedRedeemCodes"
          }
        })];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.fromMyConsole || _vm.checkPermission([_vm.consts.STAFF_CUSTOMER_VIEW]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "disabled": data.item.belong_at !== null
          },
          on: {
            "click": function click($event) {
              return _vm.showAssignModal(data.item);
            }
          }
        }, [_vm._v("指派 ")]) : _vm._e(), (_vm.fromMyConsole || _vm.checkPermission([_vm.consts.STAFF_CUSTOMER_VIEW])) && data.item.customer_id !== null ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-success",
            "disabled": data.item.redeem_at !== null
          },
          on: {
            "click": function click($event) {
              return _vm.pushRedeemCode(data.item);
            }
          }
        }, [_vm._v("發送推播 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-batch-assign",
      "title": "整批指派序號"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _vm.batchAssignStep == 1 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": !_vm.batchAssignFile
          },
          on: {
            "click": _vm.preProcessBatchAssign
          }
        }, [_vm._v(" 下一步 ")]) : _vm._e(), _vm.batchAssignStep == 2 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.goBackBatchAssign
          }
        }, [_vm._v("回上一步")]) : _vm._e(), _vm.batchAssignStep == 2 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": !_vm.canBatchAssign
          },
          on: {
            "click": _vm.batchAssign
          }
        }, [_vm._v(" 確定匯入 ")]) : _vm._e()];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_vm.batchAssignStep == 1 ? [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("依 LINE ID、手機號碼 順序比對會員")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.batchAssignFile,
      callback: function callback($$v) {
        _vm.batchAssignFile = $$v;
      },
      expression: "batchAssignFile"
    }
  }), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/batch_assign_redeem_code.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案 ")])], 1)] : _vm.batchAssignStep == 2 ? [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(" 上傳資料筆數：" + _vm._s(_vm.batchAssignAnalysis.total_member_count)), _c('br'), _vm._v(" 對應會員數量：" + _vm._s(_vm.batchAssignAnalysis.valid_member_count)), _c('br'), _vm._v(" 可用序號數量：" + _vm._s(_vm.isUnlimitedCoupon ? '無上限' : _vm.batchAssignAnalysis.valid_redeem_code_count)), _c('br')]), !_vm.canBatchAssign ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(" 可用序號不足，無法匯入 ")]) : _vm._e(), _vm.batchAssignAnalysis.valid_member_count != _vm.batchAssignAnalysis.total_member_count ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(" 上傳資料數量與對應會員數量不同，請問是否確定匯入 ")]) : _vm._e()])] : _vm._e()], 2)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "上傳序號"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _vm.imoprtRedeemCodeStep == 1 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": !_vm.file
          },
          on: {
            "click": _vm.preProcessImoprtRedeemCode
          }
        }, [_vm._v(" 下一步 ")]) : _vm._e(), _vm.imoprtRedeemCodeStep == 2 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.goBackImport
          }
        }, [_vm._v("回上一步")]) : _vm._e(), _vm.imoprtRedeemCodeStep == 2 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.imoprtRedeemCode
          }
        }, [_vm._v("確定上傳序號")]) : _vm._e()];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_vm.imoprtRedeemCodeStep == 1 ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳帳號 Excel 檔案")]), _c('ul', {
    staticClass: "text-danger"
  }, [_c('li', [_vm._v("第一欄位為序號，第二欄位為 LINE UID，第三欄位為手機號碼")]), _c('li', [_vm._v("第一欄序號不能留空，若該序號不指定會員，第二欄 LINE UID與三欄位手機號碼可以留空（可事後批次補匯入會員）")]), _c('li', [_vm._v("會員將依 LINE UID、手機號碼順序比對")])]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.file,
      callback: function callback($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  }), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/event_redeem_code_list_v2.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)] : _vm.imoprtRedeemCodeStep == 2 ? [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(" 本次上傳序號總數：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.total_code_count)), _c('br'), _vm._v(" 本次新上傳序號：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.new_code_count)), _c('br'), _vm._v(" 原本已存在序號：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.already_code_count)), _c('br')]), _c('p', [_vm._v(" 本次上傳的會員數量：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.assign_count)), _c('br'), _vm._v(" 本次新指派會員數：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.new_assigne_count)), _c('br'), _vm._v(" 原本已指派會員數：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.already_assign_count)), _c('br'), _vm._v(" 指派失敗的會員數：" + _vm._s(_vm.imoprtRedeemCodeAnalysis.fail_assign_count)), _c('br')])])] : _vm._e()], 2)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-create",
      "title": "請輸入序號"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var cancel = _ref3.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消新增 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.saveRedeemCode
          }
        }, [_vm._v("確認送出")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.redeemCodeInput,
      callback: function callback($$v) {
        _vm.redeemCodeInput = $$v;
      },
      expression: "redeemCodeInput"
    }
  })], 1)], 1), _c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    attrs: {
      "show-btn": false,
      "title": "指派優惠券",
      "only-belonged-customer": _vm.fromMyConsole
    },
    on: {
      "bind": _vm.assignRedeemCode
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }